import { render, staticRenderFns } from "./ask.vue?vue&type=template&id=25ac7688"
import script from "./ask.vue?vue&type=script&lang=js"
export * from "./ask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports